/**
 * Do not edit directly
 * Generated on Wed, 17 Sep 2025 12:45:20 GMT
 */

export const xs = "4px";
export const sm = "8px";
export const md = "16px";
export const lg = "32px";
export const xl = "64px";